module.exports = __webpack_public_path__ + "img/mypage_02.2e4ea0c1.png";